import { render } from "./EducationManagement.vue?vue&type=template&id=49a97fa0"
import script from "./EducationManagement.vue?vue&type=script&lang=js"
export * from "./EducationManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__